const VARIANTS = {
    STORE: 'store',
    PRODUCT: 'product'
};

export { VARIANTS };
